<template>
  <div id="pageEditProfile" class="bg--white">
    <!-- Head -->
    <section
      class="mobile_add_new_head bg--blue tx--bege center flex flex--content--center relative"
    >
      <div class="title">עריכת פרופיל</div>

      <router-link to="/profile" class="m_bt_head head_cancel">
        ביטול
      </router-link>

      <a
        href="javascript:void(0)"
        @click.prevent="saveProfile"
        class="m_bt_head head_save"
      >
        שמירה
      </a>
    </section>

    <!-- Hero -->
    <section class="profile-hero bg--blue center tx--white">
      <div class="profile-image relative">
        <img :src="user.image" />
      </div>
      <h1 class="title bold tx--white no-marge">
        {{ user.staticTitle }} {{ user.first_name }} {{ user.last_name }}
      </h1>
      <a
        href="javascript:void(0)"
        class="profile-edit-bt flex flex--content--center tx--under tx--white"
        @click="openRequestPhotoPopup"
      >
        <img src="assets/img/svg/date-white.svg" />
        תיאום צילום תמונה חדשה
      </a>
    </section>

    <!-- Page -->
    <section class="inner-edit-pgae">
      <!-- title -->
      <div class="box-edit">
        <div class="box-edit-title">תואר</div>
        <input type="text" v-model.trim="user.title" />
      </div>

      <!-- Job -->
      <div class="box-edit">
        <div class="box-edit-title">מומחיות</div>
        <input type="text" v-model.trim="user.job" />
      </div>

      <!-- About -->
      <div class="box-edit">
        <div class="box-edit-title">קצת עלי</div>
        <textarea v-model.trim="user.about"> </textarea>
      </div>

      <!-- Roles -->
      <div class="box-edit">
        <div class="box-edit-title">תפקידים</div>
        <div class="add_new_row" v-for="(role, i) in user.roles" :key="i">
          <textarea v-model.trim="user.roles[i]"></textarea>
        </div>
        <div
          @click="addRow(user.roles)"
          class="add_task_width add_new_task flex flex--start"
        >
          <span class="plus-circ flex flex--content--center">
            <span class="plus"></span>
          </span>
          הוספת רשומה
        </div>
      </div>

      <!-- Clinical experience -->
      <div class="box-edit">
        <div class="box-edit-title">ניסיון קליני</div>
        <div class="add_new_row" v-for="(exp, i) in user.clinical_exp" :key="i">
          <textarea v-model.trim="user.clinical_exp[i]"></textarea>
        </div>
        <div
          @click="addRow(user.clinical_exp)"
          class="add_task_width add_new_task flex flex--start"
        >
          <span class="plus-circ flex flex--content--center">
            <span class="plus"></span>
          </span>
          הוספת רשומה
        </div>
      </div>

      <!-- Education -->
      <div class="box-edit">
        <div class="box-edit-title">השכלה</div>
        <div class="add_new_row" v-for="(edu, i) in user.education" :key="i">
          <textarea v-model.trim="user.education[i]"></textarea>
        </div>
        <div
          @click="addRow(user.education)"
          class="add_task_width add_new_task flex flex--start"
        >
          <span class="plus-circ flex flex--content--center">
            <span class="plus"></span>
          </span>
          הוספת רשומה
        </div>
      </div>

      <!-- Courses -->
      <div class="box-edit">
        <div class="box-edit-title">השתלמויות</div>
        <div class="add_new_row" v-for="(course, i) in user.courses" :key="i">
          <textarea v-model.trim="user.courses[i]"></textarea>
        </div>
        <div
          @click="addRow(user.courses)"
          class="add_task_width add_new_task flex flex--start"
        >
          <span class="plus-circ flex flex--content--center">
            <span class="plus"></span>
          </span>
          הוספת רשומה
        </div>
      </div>

      <!-- Membership -->
      <div class="box-edit">
        <div class="box-edit-title">חברות באיגודים מקצועיים</div>
        <div class="add_new_row" v-for="(ms, i) in user.memberships" :key="i">
          <textarea v-model.trim="user.memberships[i]"></textarea>
        </div>
        <div
          @click="addRow(user.memberships)"
          class="add_task_width add_new_task flex flex--start"
        >
          <span class="plus-circ flex flex--content--center">
            <span class="plus"></span>
          </span>
          הוספת רשומה
        </div>
      </div>
      <a
        href="javascript:void(0)"
        @click.prevent="saveProfile"
        class="bt_blue full-width"
      >
        שמירה
      </a>
    </section>
  </div>
</template>

<script>
import { requestUpdateUserDetails } from "../api/api-quatro";
import { mapActions } from "vuex";
import Error from "@/components/Popups/Error";
import ConfirmEditProfile from "@/components/Popups/ConfirmEditProfile";
import EditProfilePhotoRequest from "@/components/Popups/EditProfilePhotoRequest";
export default {
  name: "ProfileEdit",
  data() {
    return {
      /// Data
      license: "",
      isLoading: false,

      /// Form data
      user: {
        title: "",
        staticTitle: "",
        first_name: "",
        last_name: "",
        image: "",
        about: "",
        job: "",
        roles: [],
        clinical_exp: [],
        education: [],
        courses: [],
        memberships: []
      }
    };
  },
  methods: {
    ...mapActions(["GET_USER_PROFILE"]),
    openRequestPhotoPopup() {
      this.$modal.show(EditProfilePhotoRequest);
    },
    addRow(array) {
      const lastChild = array[array.length - 1];
      if (lastChild === "" || lastChild.trim() === "") return;
      array.push("");
    },
    async saveProfile() {
      if (this.isLoading) return;
      this.isLoading = true;

      this.user.roles = this.user.roles.filter(item => item.trim() !== "");
      this.user.clinical_exp = this.user.clinical_exp.filter(
        item => item.trim() !== ""
      );
      this.user.education = this.user.education.filter(
        item => item.trim() !== ""
      );
      this.user.courses = this.user.courses.filter(item => item.trim() !== "");
      this.user.memberships = this.user.memberships.filter(
        item => item.trim() !== ""
      );

      const body = {
        title: this.user.title,
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        image: this.user.image,
        about: this.user.about,
        job: this.user.job,
        roles: this.user.roles,
        clinical_exp: this.user.clinical_exp,
        education: this.user.education,
        courses: this.user.courses,
        memberships: this.user.memberships
      };

      try {
        const res = await requestUpdateUserDetails(this.license, body);
        this.$modal.show(ConfirmEditProfile);
        if (res["status"] === "success") this.$router.push("/profile");
        this.isLoading = false;
      } catch (error) {
        this.$modal.show(Error, {
          title: "התרחשה שגיאה, אנא נסו שנית מאוחר יותר"
        });
        this.$router.push("/profile");
        this.isLoading = false;
        console.log(error);
      }
    }
  },
  async created() {
    this.user = await this.GET_USER_PROFILE();
    // this.isLoading = false;
  }
};
</script>

<style scoped>
.full-width {
  width: 100%;
}
</style>
